import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Button } from '../components/ui/Button';
import { products } from '../data/products';
export function ProductsPage() {
  return <div className="pt-24 pb-16" data-id="element-461">
      {/* Hero */}
      <section className="bg-white pb-20" data-id="element-462">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-463">
          <SectionHeading eyebrow="Our Products" title="An integrated ecosystem of business tools" description="Designed for growing companies that need enterprise power without the complexity." className="mb-16" data-id="element-464" />
        </div>
      </section>

      {/* Products List */}
      <section className="bg-slate-50 py-20" data-id="element-465">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12" data-id="element-466">
          {products.map((product, index) => {
          const Icon = product.icon;
          const isEven = index % 2 === 0;
          return <motion.div key={product.id} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden hover:shadow-xl transition-shadow duration-500" data-id="element-467">
                <div className="grid md:grid-cols-2 gap-0" data-id="element-468">
                  <div className={`p-8 md:p-12 flex flex-col justify-center ${isEven ? 'md:order-1' : 'md:order-2'}`} data-id="element-469">
                    <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 bg-${product.color}-100 text-${product.color}-600`} data-id="element-470">
                      <Icon size={28} data-id="element-471" />
                    </div>
                    <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-472">
                      {product.name}
                    </h2>
                    <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-473">
                      {product.description}
                    </p>

                    <div className="space-y-3 mb-8" data-id="element-474">
                      {product.features.slice(0, 3).map((feature, i) => <div key={i} className="flex items-center text-slate-700" data-id="element-475">
                          <Check size={18} className={`mr-3 text-${product.color}-500`} data-id="element-476" />
                          {feature}
                        </div>)}
                    </div>

                    <div className="flex items-center space-x-4" data-id="element-477">
                      <Button href={`/products/${product.id}`} variant="outline" data-id="element-478">
                        Learn More
                      </Button>
                      <Link to={`/products/${product.id}`} className="text-navy-600 font-medium hover:underline flex items-center" data-id="element-479">
                        View Details <ArrowRight size={16} className="ml-1" data-id="element-480" />
                      </Link>
                    </div>
                  </div>

                  <div className={`bg-slate-100 min-h-[300px] md:min-h-full flex items-center justify-center p-8 ${isEven ? 'md:order-2' : 'md:order-1'}`} data-id="element-481">
                    {/* Placeholder for product screenshot - using a colored block for now */}
                    <div className={`w-full max-w-md aspect-video rounded-xl shadow-lg bg-white flex items-center justify-center border border-slate-200 relative overflow-hidden group`} data-id="element-482">
                      <div className={`absolute inset-0 bg-gradient-to-br from-${product.color}-50 to-white opacity-50`} data-id="element-483"></div>
                      <Icon size={64} className={`text-${product.color}-200 group-hover:scale-110 transition-transform duration-500`} data-id="element-484" />
                      <div className="absolute bottom-4 right-4 bg-white px-3 py-1 rounded-lg text-xs font-semibold shadow-sm text-slate-500" data-id="element-485">
                        {product.name} Dashboard
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-white text-center" data-id="element-486">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-487">
          <h2 className="text-3xl font-bold text-slate-900 mb-6" data-id="element-488">
            Not sure which tools you need?
          </h2>
          <p className="text-lg text-slate-600 mb-8" data-id="element-489">
            Our team can help you audit your current operations and recommend
            the right stack for your business.
          </p>
          <Button href="/contact" size="lg" data-id="element-490">
            Talk to an Expert
          </Button>
        </div>
      </section>
    </div>;
}